module.exports = __webpack_public_path__ + "static/img/struct1.28e7110.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/struct1.png
// module id = Va3D
// module chunks = 1